<app-message [service]="messageService"></app-message>

<form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
  <div class="container-fluid">
    <div class="col-12">

      <div class="mb-3">
        <label for="firstName" i18n="@@FirstnameLabel">Vorname</label>
        <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="Vorname" i18n-placeholder="@@FristNamePlaceholder"/>

        <div class="error">
          <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
        </div>
      </div>

      <div class="mb-3">
        <label for="lastname" i18n="@@LastnameLabel">Nachname*</label>
        <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="Nachname*" i18n-placeholder="@@LastnamePlaceholder"/>

        <div class="error">
          <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')" i18n="@@LastnameRequiredError">Nachname wird benötigt</em>
          <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')" i18n="@@IncorrectInputError">Falsche Eingabe</em>
        </div>
      </div>

      <div class="mb-3">
        <label for="email" i18n="@@E-MailLabel">E-Mail*</label>
        <input type="text" id="email" formControlName="email" class="form-control" placeholder="E-Mail*" i18n-placeholder="@@EmailPlaceholder"/>

        <div class="error">
          <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'email')" i18n="@@E-MailIncorrectInputError">E-Mail ist nicht gültig</em>
          <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'required')" i18n="@@E-MailRequiredError">E-Mail wird benötigt</em>
        </div>
      </div>

      <div class="mb-3">
        <label for="inviteLink" i18n="@@InviteLinkForUserLabel">Link für den Benutzer</label>
        <div class="input-group">
          <input type="text" id="inviteLink" class="form-control" [readonly]="true" />
          <button i18n="@@OutlineSecondaryButton" class="btn btn-outline-secondary" type="button" id="button-dp"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy" data-bs-toggle="tooltip" data-bs-placement="left" title="" (click)="copyInviteLink()" data-bs-original-title="Hier klicken um den Link in die Zwischenablage zu kopieren" i18n-data-bs-original-title="@@ClickToCopyInvite" aria-label="Hier klicken um den Link in die Zwischenablage zu kopieren" i18n-aria-label="@@ClickToCopyInvite"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg></button>
          <div id="dpHelp" class="form-text" i18n="@@InviteLinkHelpText">
            Der generierte Link ist zur Weitergabe an den Benutzer
            vorgesehen.
            Mit diesem Link kann sich der Benutzer registrieren und wird automatisch ihrer Benutzerübersicht
            zugeordnet. Sie können diesen Link selbst kopieren und an den Empfänger versenden oder Sie nutzen
            die interne Versandfunktion.
          </div>
        </div>
      </div>

    </div>
    <div class="col-12"><span class="text-muted" i18n="@@RequiredFieldsLabel">*Pflichtfelder</span></div>
  </div>
</form>
